// extracted by mini-css-extract-plugin
module.exports = {"root":"ChoiceImage_root__7T6dk"};